export default __webpack_public_path__ + "static/media/Logo1.36a88276.png";